import Auth from "@/api/system/Auth";
import Roles from "@/api/system/Roles";
import Users from "@/api/system/Users";
import Profile from "@/api/system/Profile";
import Clients from "@/api/system/Clients";
import Countries from "@/api/system/Countries";
import Languages from "@/api/system/Languages";
import StudyProgram from "@/api/system/StudyProgram";
import Universities from "@/api/system/Universities";
import Specialities from "@/api/system/Specialities";
import BudgetPlaces from "@/api/system/BudgetPlaces";
import Applications from "@/api/system/Applications";
import ApplicationRequests from "@/api/system/ApplicationRequests";
import ApplicationStatuses from "@/api/system/ApplicationStatuses";

export default {
  auth: () => new Auth(),
  roles: () => new Roles(),
  users: () => new Users(),
  profile: () => new Profile(),
  clients: () => new Clients(),
  countries: () => new Countries(),
  languages: () => new Languages(),
  studyPrograms: () => new StudyProgram(),
  universities: () => new Universities(),
  specialities: () => new Specialities(),
  budgetPlaces: () => new BudgetPlaces(),
  applications: () => new Applications(),
  applicationRequests: () => new ApplicationRequests(),
  applicationStatuses: () => new ApplicationStatuses(),
};
